import { render, staticRenderFns } from "./GemAIBanner.vue?vue&type=template&id=3927c3a4&scoped=true&"
import script from "./GemAIBanner.vue?vue&type=script&lang=js&"
export * from "./GemAIBanner.vue?vue&type=script&lang=js&"
import style0 from "./GemAIBanner.vue?vue&type=style&index=0&id=3927c3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3927c3a4",
  null
  
)

export default component.exports